import Vue from 'vue'
import loadingComponent from '../components/loading'
import alertComponent from '../components/alert'
import confirmComponent from '../components/confirm'
import eventpopupComponent from '../components/eventPopup'
import selectRegionComponent from '../components/selectRegion'

let plugin = {};

plugin.install = (Vue) =>{
  const plugin_loading_instance = Vue.extend(loadingComponent);
  const plugin_loading = new plugin_loading_instance();
  document.body.appendChild(plugin_loading.$mount().$el);

  const plugin_alert_instance = Vue.extend(alertComponent);
  const plugin_alert = new plugin_alert_instance();
  document.body.appendChild(plugin_alert.$mount().$el);

  const plugin_confirm_instance = Vue.extend(confirmComponent);
  const plugin_confirm = new plugin_confirm_instance();
  document.body.appendChild(plugin_confirm.$mount().$el);

  const plugin_eventpopup_instance = Vue.extend(eventpopupComponent);
  const plugin_eventpopup = new plugin_eventpopup_instance();
  document.body.appendChild(plugin_eventpopup.$mount().$el);

  const plugin_selectRegion_instance = Vue.extend(selectRegionComponent);
  const plugin_selectRegion = new plugin_selectRegion_instance();
  document.body.appendChild(plugin_selectRegion.$mount().$el);

  Vue.prototype.$showCustomLoading = ( ) => {
    plugin_loading.show = true;
  }

  Vue.prototype.$dismissCustomLoading = ( ) => {
    plugin_loading.show = false;
  }

  Vue.prototype.$customAlert = ( params ) => {
    plugin_alert.params.show = true;

    if(params['title'] !== undefined){
      plugin_alert.params.title = params.title;
    }

    if(params['message'] !== undefined){
      plugin_alert.params.message = params.message;
    }

    plugin_alert.params.success = () =>{
      plugin_alert.params.show = false;
      if(typeof params['success'] === "function"){
        params.success();
      }
    }
  }

  Vue.prototype.$customConfirm = (params) =>{
    let p = plugin_confirm;
    p.params.show = true;
    if(params['title'] !== undefined){
      p.params.title = params.title;
    }

    if(params['message'] !== undefined){
      p.params.message = params.message;
    }
    p.params.success = () =>{
      p.params.show = false;
      if(typeof params['success'] === "function"){
        params.success();
      }
    }

    p.params.fail = function(){
      p.params.show = false;
      if(typeof params['fail'] === "function"){
        params.fail();
      }
    }
  }

  Vue.prototype.$selectRegion = ( params ) => {
    let p = plugin_selectRegion;
    p.list = params.list;
    p.show = true;
    p.success = ( data ) =>{
      p.show = false;
      if(typeof params['success'] === "function"){
        params.success( data );
      }
    }

  }

  Vue.prototype.$eventpopup = ( params ) => {
    let p = plugin_eventpopup;

    let date = new Date();
    var today = `${date.getFullYear()}${date.getMonth() + 1}${date.getDate()}`;
    if(window.localStorage.getItem("eventStorage") !== null){
      let eventStorage = JSON.parse(window.localStorage.getItem("eventStorage"));
      if(!eventStorage.show){
        if(eventStorage.date === today){
          if(typeof params['fail'] === "function"){
            params.fail();
          }
          return;
        }else{
          window.localStorage.setItem("eventStorage" , JSON.stringify({
            show:true
            ,date:''
          }) );
        }
      }
    }
    p.show = true;
    if(params['imgURL'] !== undefined ){
      p.imgURL = params.imgURL;
    }
    if(params['linkURL'] !== undefined ){
      p.linkURL = params.linkURL;
    }

    p.success = ( todayClose ) =>{
      p.show = false;
      if(todayClose){
        window.localStorage.setItem("eventStorage" , JSON.stringify({
          show:false
          ,date:today
        }) );
      }
      if(typeof params['success'] === "function"){
        params.success();
      }
    }

  }
};

export default plugin



// WEBPACK FOOTER //
// ./src/utils/12cm-ui.js